import React, { useState } from "react";
import { Button, FormGroup, Col, Row, Container } from "reactstrap";
import { TextareaAutosize } from "@mui/material";
import { useSelector } from "react-redux";

const ChatOikos = () => {
  const { user } = useSelector(state => state.auth);
  const [mensagens, setMensagens] = useState([]);
  const [mensagemAtual, setMensagemAtual] = useState("");
  const [carregando, setCarregando] = useState(false);

  const enviar = async () => {
    if (!mensagemAtual.trim()) return;

    const novaPergunta = { role: "user", content: mensagemAtual };
    setMensagens((m) => [...m, novaPergunta]);
    setMensagemAtual("");
    setCarregando(true);

    try {
      const res = await fetch("https://n8n.ecoss.is/webhook/chatbot_oikos", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome: user.pf_nomeExibicao,
          mail: user.pf_mail,
          id: user.pf_id,
          mensagem: novaPergunta.content
        })
      });

      const data = await res.json();
      const novaResposta = { role: "assistant", content: data[0].resposta_bot };
      setMensagens((m) => [...m, novaResposta]);
    } catch (e) {
      setMensagens((m) => [
        ...m,
        { role: "assistant", content: "Erro ao consultar a IA." }
      ]);
    }

    setCarregando(false);
  };

return (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      height: "100%",
      padding: 0,
      boxSizing: "border-box",
      background: "#fff"
    }}
  >
    <div style={{ padding: "0 0 12px 0", minHeight: 24 }}>
      <h2 style={{
        margin: "0 0 12px 0",
        fontSize: 22,
        fontWeight: 600,
        color: "#495057"
      }}>
        Chat com a IA da Ecossis
      </h2>
    </div>

    {/* Caixa de histórico do chat */}
    <div
      id="chat-ecossis-box"
      style={{
        flex: 1,
        overflowY: "auto",
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        padding: "16px 12px",
        marginBottom: 12,
        background: "#f7f7fa",
        minHeight: 120
      }}
    >
      {mensagens.length === 0 && (
        <div style={{ color: "#aaa", textAlign: "center" }}>
          Nenhuma mensagem ainda. Faça sua pergunta!
        </div>
      )}
      {mensagens.map((m, i) => (
        <div
          key={i}
          style={{
            marginBottom: 10,
            textAlign: m.role === "user" ? "right" : "left"
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              color: m.role === "user" ? "#0d6efd" : "#388e3c"
            }}
          >
            {m.role === "user" ? m.nome || "Você" : "Ecossis"}
          </span>
          <span style={{
            display: "inline-block",
            marginLeft: 8,
            background: m.role === "user" ? "#e3f2fd" : "#e8f5e9",
            padding: "6px 10px",
            borderRadius: 8,
            maxWidth: "75%",
            wordBreak: "break-word"
          }}>
            {m.content}
          </span>
        </div>
      ))}
      {carregando && (
        <div>
          <em>Ecossis está digitando...</em>
        </div>
      )}
    </div>

    {/* Campo de entrada e botão */}
    <FormGroup style={{ margin: 0 }}>
      <Row>
        <Col sm={9} style={{ paddingRight: 4 }}>
          <TextareaAutosize
            placeholder="Digite sua pergunta"
            minRows={2}
            maxRows={4}
            value={mensagemAtual}
            onChange={(e) => setMensagemAtual(e.target.value)}
            className="form-control"
            style={{
              width: "100%",
              resize: "none",
              boxSizing: "border-box"
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                enviar();
              }
            }}
          />
        </Col>
        <Col sm={3} style={{ paddingLeft: 4 }}>
          <Button
            color="success"
            onClick={enviar}
            disabled={carregando}
            style={{
              width: "100%",
              minHeight: 48,
              fontWeight: "bold"
            }}
          >
            Enviar
          </Button>
        </Col>
      </Row>
    </FormGroup>
  </div>
);

};

export default ChatOikos;
